import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HelpersService } from '../services/helpers.service';
import { ProfileToUnify, User } from './authentication.models';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  public profileToUnify: ProfileToUnify = new ProfileToUnify();
  public storageUser = 'mu-storage-user';
  //private signatureTimestampStorage = 'mu-signature-timestamp';

  constructor(private router: Router,
              private helpersService: HelpersService,
              private http: HttpClient) {}

  get user(): User | null {
    if (!this.helpersService.isBrowser) return null;
    const userData = localStorage.getItem(this.storageUser);
    return userData ? JSON.parse(userData) : null;
  }

  get isLogged(): any {
    return !!(this.user && this.helpersService.accessToken);
  }

  get isNewUser(): any {
    return false;
  }

  public saveUser(userData: User): void {
    if (!this.helpersService.isBrowser) return;
    if (userData) {
      localStorage.setItem(this.storageUser, JSON.stringify(userData));
      //this.signatureTimestamp = (userData.signatureTimestamp);
    }
  }

  // get signatureTimestamp(): string | null {
  //   if (!this.helpersService.isBrowser) return null;
  //   return localStorage.getItem(this.signatureTimestampStorage);
  // }

  // set signatureTimestamp(timestamp: string) {
  //   if (timestamp && timestamp.length > 0) {
  //     let newTimestamp = timestamp;
  //     if (timestamp.length < 13) newTimestamp = newTimestamp + '000'; // signatureTimestamp viene passato in secondi e non in millisecondi
  //     localStorage.setItem(this.signatureTimestampStorage, newTimestamp);
  //   }
  // }

  // private isSignatureTimestampExpired(): boolean {
  //   const oneHourInMilliseconds = 3600000;
  //   const expiration = Number(this.signatureTimestamp) + oneHourInMilliseconds;
  //   return new Date().getTime() > expiration;
  // }

  public clearStorage() {
    if (!this.helpersService.isBrowser) return;
    localStorage.removeItem(this.storageUser);
    localStorage.removeItem(this.helpersService.storageAccessTokenKey);
    // localStorage.removeItem(this.signatureTimestampStorage);
  }

  public logout(): void {
    this.router.navigateByUrl('/auth/logout');
  }

  public get userInitials() {
    if (this.user && this.user.profile) {
      const firstNameChar = this.user.profile.firstName.charAt(0);
      const lastNameChar = this.user.profile.lastName.charAt(0);
      return firstNameChar + lastNameChar
    } else {
      return "US"
    }
  }

  public sendNewUser({uuid = ''}): Observable<any>{
      const endpoint = environment.bffBaseUrl + '/api/v1/enrollments';
      const req = { uuid };
      return this.http.post(endpoint, req)
  }

  public verifyUserEmail({ email = '', fiscalCode = '', uid = ''}): Observable<any> {
    const endpoint = environment.bffBaseUrl + '/api/v1/enrollments/verify-email';
    const req = { email, fiscalCode, uid };
    return this.http.post(endpoint, req)
  }

  public sendUnificationCode({code = '', email = '', fiscalCode = '', uid = ''}): Observable<any>{
    const endpoint = environment.bffBaseUrl + '/api/v1/enrollments/verify-code';
    const req = { code, email, fiscalCode, uid };
    return this.http.post(endpoint, req)
  }

  sendResetPassword() {
    const endpoint = environment.bffBaseUrl + '/api/v1/accounts/reset-password';
    return this.http.post(endpoint, '', this.helpersService.getHTTPHeader())
  }

  deleteUserProfile() {
    const endpoint = environment.bffBaseUrl + '/api/v1/accounts/';
    return this.http.delete(endpoint, this.helpersService.getHTTPHeader())
  }

  public getCartByUuid(cartUuid: string): Observable<any> {
    const endpoint = environment.bffBaseUrl + `/api/v1/carts/${cartUuid}`;
    return this.http.get(endpoint, this.helpersService.getHTTPHeader()).pipe(
      map((res: any) => {
        return res;
      }),
    );

  }
}
